import * as React from 'react';
import antd from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import styled from 'styled-components';
import FormControl from '../../Forms/FormControl';

const { Form } = antd;

export const StyleLoginForm = styled(Form)`
  max-width: 300px;
  min-width: 300px;

  text-align: center;

  .login-form-button {
    width: 100%;
  }
`;

export const TextLinksFormItem = styled(Form.Item)`
justifyContent: "center";
alignItems: "center";
  .ant-form-item-control {
    line-height: 20px;
  }

  button {
    margin-top: 10px;
    margin-bottom: 10px;
  }
`;
